/* KA Touchdown Paris — small modules keyed by data-module, no framework. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const emit = (name, detail) => document.dispatchEvent(new CustomEvent(name, { detail }));
  const designMode = () => !!(window.Shopify && window.Shopify.designMode);
  /* Handoff 32: cart/add.js only from the signed-in state; otherwise go to the sign-in (store gate). */
  const signedIn = () => document.body.dataset.signedIn === '1';
  const toSignIn = () => { window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent(window.location.pathname)}`; };
  const modules = {};
  /* Handoff 62 (5): page views of this visit, read by the showroom pop-up. */
  try { sessionStorage.setItem('ka-views', String((parseInt(sessionStorage.getItem('ka-views'), 10) || 0) + 1)); } catch (e) { /* storage blocked */ }

  /* Hero video: grayscale pulse and the Sound pill. */
  modules.hero = (el) => {
    const mono = (parseFloat(el.dataset.mono) || 3) * 1000;
    const color = (parseFloat(el.dataset.color) || 2) * 1000;
    const loop = () => setTimeout(() => {
      el.classList.add('is-color');
      setTimeout(() => { el.classList.remove('is-color'); loop(); }, color);
    }, mono);
    if (el.dataset.pulse !== 'off') loop();

    const video = $('[data-hero-video]', el);
    const hasFilm = video && (video.getAttribute('src') || $('source', video));
    if (!hasFilm) return;
    const sound = $('[data-sound]', el);
    /* The sound choice is kept for the visit (sessionStorage['ka-sound'] = '1' / '0'); storage may be blocked. */
    const read = () => { try { return window.sessionStorage.getItem('ka-sound') === '1'; } catch (e) { return false; } };
    const write = (on) => { try { window.sessionStorage.setItem('ka-sound', on ? '1' : '0'); } catch (e) { /* storage blocked */ } };
    const label = () => {
      if (!sound) return;
      /* The label names the action (Kolja, 26 Oct): muted → "Sound on", with sound → "Sound off". */
      sound.textContent = video.muted ? sound.dataset.labelOn : sound.dataset.labelOff;
      sound.setAttribute('aria-pressed', String(!video.muted));
    };
    /* Browsers allow sound only after a real tap, click or key press on the page (Safari and phones always,
       Chrome not always). 27 Oct: when playback with sound is refused, the film plays muted and the next real
       gesture anywhere on the page starts it again, with sound if the visitor chose sound earlier in the visit.
       Only pointerup / touchend / click / keydown count as a gesture; pointerdown from a finger does not. */
    const gestures = ['pointerup', 'touchend', 'click', 'keydown'];
    let armed = false;
    const disarm = () => { armed = false; gestures.forEach((t) => document.removeEventListener(t, onGesture, true)); };
    const arm = () => { if (armed) return; armed = true; gestures.forEach((t) => document.addEventListener(t, onGesture, { capture: true, passive: true })); };
    /* Play; if the browser refuses playback with sound, fall back to muted, offer "Sound on" and wait for a gesture. */
    let started = false;
    const start = () => {
      started = true;
      const p = video.play();
      if (p) p.catch((err) => {
        if (err && err.name === 'AbortError') return; /* interrupted by a newer play / load, not refused */
        if (!video.muted) { video.muted = true; label(); video.play().catch(() => {}); }
        arm();
      });
    };
    /* 27 Oct (2): Safari can leave the audio closed when a running muted film is only un-muted (e.g. after
       "Sound off"); restarting playback inside the tap opens it again. Call only from a tap / click / key. */
    const withSound = () => {
      video.muted = false;
      if (!video.paused) video.pause();
      start();
    };
    function onGesture(e) {
      if (e.type === 'keydown' && e.key === 'Escape') return; /* Escape is no gesture for the browser */
      disarm();
      if (sound && e.target instanceof Element && e.target.closest('[data-sound]')) return; /* the pill handles its own click */
      if (sound && read() && video.muted) withSound(); else start();
    }
    /* The pill always shows the film's real state, also when the browser mutes or stops it on its own. */
    video.addEventListener('volumechange', label);
    /* If the browser stops the film with sound by itself (Safari after a refused un-mute, an iPhone audio
       interruption), it goes on muted and the next tap brings the sound back. */
    video.addEventListener('pause', () => {
      if (started && video.paused && !video.muted && !video.ended && document.visibilityState === 'visible') {
        video.muted = true;
        video.play().catch(() => {});
        arm();
      }
    });
    /* Back in the tab, or back on the page from the browser's cache: the film runs again with the visit's choice. */
    document.addEventListener('visibilitychange', () => { if (started && document.visibilityState === 'visible' && video.paused) start(); });
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      video.muted = !(sound && read());
      label();
      if (started) start();
    });
    video.muted = !(sound && read());
    label();
    /* Handoff 62 (13): under 768 px the hero shows its poster until the first tap, then plays. */
    if (window.matchMedia('(max-width: 767px)').matches) {
      video.removeAttribute('autoplay');
      video.pause();
      try { video.load(); } catch (e) { /* keeps the poster */ }
      arm();
    } else {
      start();
    }
    /* Kolja, 29 Oct: the Sound pill moves into the bar next to MENU (replaceChildren: an editor re-render
       brings a new pill, the old one goes). Without that slot it stays on the film, as before. */
    const slot = $('[data-sound-slot]');
    if (sound && slot) slot.replaceChildren(sound);
    /* Kolja, 26 Oct: on the film the Sound pill sits left of the fixed WhatsApp pill, never under it.
       --sound-right is the WhatsApp pill's left edge plus a gap; without that pill the CSS fallback applies. */
    const wa = $('.whatsapp-pill');
    if (sound && wa && !slot) {
      const place = () => {
        const w = wa.getBoundingClientRect();
        if (w.width) el.style.setProperty('--sound-right', Math.round(document.documentElement.clientWidth - w.left + (w.height < 44 ? 8 : 12)) + 'px');
      };
      place();
      window.addEventListener('resize', place);
      if (document.fonts) document.fonts.ready.then(place);
    }
    if (sound) {
      sound.addEventListener('click', () => {
        const on = video.muted;
        write(on);
        if (on) withSound(); /* on phones the pill may be the first tap */
        else { video.muted = true; if (video.paused) start(); }
        label();
      });
    }
  };

  /* Handoff 62 (8): on the product page the back link reads "‹ Catalogue", or "‹ Store" when the visitor came from the store grid. */
  const back = document.querySelector('[data-back-link]');
  if (back && document.referrer) {
    try {
      const from = new URL(document.referrer);
      if (from.host === window.location.host && from.pathname.indexOf(back.dataset.storePath || '/pages/store') === 0) {
        back.href = back.dataset.storeUrl; back.textContent = back.dataset.labelStore;
      }
    } catch (e) { /* invalid referrer */ }
  }

  /* Header: MENU / BACK toggles the menu carousel over the hero. */
  modules.header = (el) => {
    const toggle = $('[data-menu-toggle]', el);
    if (!toggle) return;
    const setOpen = (open) => {
      document.body.classList.toggle('is-menu-open', open);
      toggle.textContent = open ? toggle.dataset.labelOpen : toggle.dataset.labelClosed;
      toggle.setAttribute('aria-expanded', open);
    };
    toggle.addEventListener('click', () => {
      /* In the compact bar MENU goes back to the top, closes the content and opens the carousel. */
      if (document.body.classList.contains('is-compact')) {
        emit('ka:collapse');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setOpen(true);
        return;
      }
      const open = !document.body.classList.contains('is-menu-open');
      setOpen(open);
      /* closing drops #menu so a reload shows the plain hero */
      if (!open && window.location.hash === '#menu') history.replaceState(null, '', window.location.pathname + window.location.search);
    });
    /* Home opened via a MENU link (/#menu) starts with the carousel open */
    if (document.body.classList.contains('template-index') && window.location.hash === '#menu') setOpen(true);
    /* Kolja, 29 Oct: on the pages with menu mode (Home, Catalogue, Projects) 10 s without activity (no scroll,
       tap, click, mouse move, wheel or key) bring the page back to menu mode with the full KA logo: open line /
       project closed, back at the top, carousel open. Not while a picture / film is open full screen, the
       showroom popup is open or a field has the focus. */
    if (document.body.classList.contains('is-hero-page') && $('[data-module="carousel"]')) {
      const IDLE_MS = 10000;
      let idle = 0;
      const restart = () => { clearTimeout(idle); idle = setTimeout(toMenu, IDLE_MS); };
      function toMenu() {
        const f = document.activeElement;
        if (designMode() || document.body.classList.contains('is-lightbox-open') || document.body.classList.contains('is-popup-open') || (f && f.matches('input, textarea, select'))) { restart(); return; }
        emit('ka:collapse');
        window.scrollTo({ top: 0, behavior: 'instant' }); /* a jump, not a glide (html has scroll-behavior: smooth): the full logo must be back for sure */
        window.dispatchEvent(new Event('scroll')); /* the sticky header switches back to the full logo now, not on the next real scroll */
        setOpen(true);
      }
      ['scroll', 'pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart'].forEach((t) => window.addEventListener(t, restart, { passive: true }));
      restart();
    }
  };

  /* Sticky header: full block at the top, compact bar after 120 px; content keeps the full height as padding. */
  const stickyHeader = () => {
    const bar = $('.header-section');
    if (!bar) return;
    const root = document.documentElement;
    const measure = () => {
      if (document.body.classList.contains('is-compact')) return;
      root.style.setProperty('--header-space', `${bar.offsetHeight}px`);
    };
    /* Kolja, 29 Oct: the logo no longer morphs (row ↔ stack jumped); it takes its new size while invisible and
       fades in — the full logo slowly and slightly later, once the bar has grown. */
    let entered = 0;
    const enter = (compact) => $$('.hdr .logo-block').forEach((logo) => {
      logo.classList.remove('is-entering', 'is-entering--full');
      void logo.offsetWidth; /* restart the animation */
      logo.classList.add('is-entering');
      if (!compact) logo.classList.add('is-entering--full');
      /* safety net: the logo is never left invisible if a browser stalls the animation */
      clearTimeout(entered);
      entered = setTimeout(() => $$('.hdr .logo-block').forEach((l) => l.classList.remove('is-entering', 'is-entering--full')), 1500);
    });
    $$('.hdr .logo-block').forEach((logo) => logo.addEventListener('animationend', () => logo.classList.remove('is-entering', 'is-entering--full')));
    const update = () => {
      const was = document.body.classList.contains('is-compact');
      /* compact below 120 px, full again above 80 px: no flicker around one line */
      const compact = (window.scrollY || root.scrollTop || 0) > (was ? 80 : 120);
      if (compact !== was) {
        if (compact) measure();
        document.body.classList.toggle('is-compact', compact);
        $$('.hdr').forEach((h) => h.classList.toggle('compact', compact));
        enter(compact);
      }
    };
    measure();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
  };

  /* Menu carousel: server-rendered slides, one visible at a time. */
  modules.carousel = (el) => {
    const count = $$('[data-dot]', el).length;
    if (!count) return;
    let i = 0;
    let syncVideos = () => {};
    const show = (k) => {
      i = (k + count) % count;
      $$('[data-slide]', el).forEach((n) => { n.hidden = +n.dataset.slide !== i; });
      syncVideos();
      $$('[data-dot]', el).forEach((n) => {
        if (+n.dataset.dot === i) n.setAttribute('aria-current', 'true');
        else n.removeAttribute('aria-current');
      });
    };
    $$('[data-prev]', el).forEach((b) => b.addEventListener('click', () => show(i - 1)));
    $$('[data-next]', el).forEach((b) => b.addEventListener('click', () => show(i + 1)));
    $$('[data-dot]', el).forEach((b) => b.addEventListener('click', () => show(+b.dataset.dot)));
    document.addEventListener('shopify:block:select', (e) => {
      const head = e.target.closest('[data-slide]');
      if (!head || !el.contains(head)) return;
      document.body.classList.add('is-menu-open');
      show(+head.dataset.slide);
    });

    /* Card videos (Handoff 34): only the visible card plays, only while the menu is open; reduced motion never plays. */
    const videos = $$('[data-menu-video]', el);
    if (videos.length) {
      const still = window.matchMedia('(prefers-reduced-motion: reduce)');
      const wasOn = new WeakMap();
      syncVideos = () => videos.forEach((v) => {
        const on = document.body.classList.contains('is-menu-open') && !still.matches && !v.closest('[data-slide]').hidden;
        /* Handoff 41: a card without loop (Catalogue) plays once — from 0 each time it comes into view, stopping on its last frame. */
        if (on && !wasOn.get(v) && !v.loop) { try { v.currentTime = 0; } catch (e) { /* not loaded yet */ } }
        wasOn.set(v, on);
        if (on) { if (v.loop || !v.ended) { const p = v.play(); if (p) p.catch(() => {}); } } else v.pause();
      });
      new MutationObserver(syncVideos).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      syncVideos();
    }
  };

  /* Topic carousel + content on click, with auto-collapse back at the top. */
  modules.topics = (el) => {
    const source = $('[data-topics]');
    if (!source) return;
    const topics = JSON.parse(source.textContent);
    if (!topics.length) return;
    /* Topic blocks (Handoff 30): a card's own image / kicker / title / caption override the automatic ones. */
    const ovSource = $('[data-topic-overrides]');
    const overrides = ovSource ? JSON.parse(ovSource.textContent) : [];
    topics.forEach((t) => {
      const o = overrides.find((x) => (x.kind === 'collection' && x.match === t.id)
        || (x.kind === 'chapter' && x.match && (x.match === String(t.id).toLowerCase() || x.match === String(t.title || '').trim().toLowerCase()))); /* chapter block ID (select); an old title value still resolves (Handoff 66) */
      if (!o) return;
      if (o.img) t.img = o.img;
      if (o.video) t.video = o.video;
      if (o.kicker) t.kicker = o.kicker;
      if (o.title) t.title = o.title;
      if (o.caption) t.caption = o.caption;
    });
    /* Card video (Handoff 35): plays while the topic carousel is visible (menu closed); reduced motion keeps the poster. */
    const cardVideo = $('[data-topic-video]', el);
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let videoKey = '';
    const syncVideo = () => {
      if (!cardVideo || cardVideo.hidden) return;
      if (!document.body.classList.contains('is-menu-open') && !reduced.matches) { const p = cardVideo.play(); if (p) p.catch(() => {}); } else cardVideo.pause();
    };
    const showVideo = (t) => {
      if (!cardVideo) return;
      const v = t.video;
      cardVideo.hidden = !v;
      img.hidden = !!v;
      if (!v) { cardVideo.pause(); return; }
      const key = `${v.webm}|${v.mp4}`;
      if (key !== videoKey) {
        videoKey = key;
        cardVideo.innerHTML = '';
        if (v.poster) cardVideo.poster = v.poster; else cardVideo.removeAttribute('poster');
        [[v.webm, 'video/webm'], [v.mp4, 'video/mp4']].forEach(([src, type]) => {
          if (!src) return;
          const so = document.createElement('source'); so.src = src; so.type = type; cardVideo.appendChild(so);
        });
        cardVideo.setAttribute('aria-label', t.title || '');
        cardVideo.load();
      }
      syncVideo();
    };
    if (cardVideo) new MutationObserver(syncVideo).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    const kicker = $('[data-topic-kicker]', el);
    const title = $('[data-topic-title]', el);
    const img = $('[data-topic-img]', el);
    const caption = $('[data-topic-caption]', el);
    const dots = $('[data-topic-dots]', el);
    const parts = () => $$('[data-content]');
    let i = Math.max(0, topics.findIndex((t) => t.id === source.dataset.current));
    let shown = false;

    dots.innerHTML = '';
    topics.forEach((t, k) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'dots__dot';
      dot.setAttribute('aria-label', t.title);
      dot.addEventListener('click', () => render(k));
      dots.appendChild(dot);
    });

    const render = (k) => {
      i = (k + topics.length) % topics.length;
      const t = topics[i];
      title.textContent = t.title;
      if (kicker) kicker.textContent = t.kicker || el.dataset.kicker || '';
      /* A card without a picture stays empty instead of keeping the previous card's picture. */
      img.src = t.img || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
      showVideo(t);
      img.alt = t.title;
      const n = t.count != null ? t.count : (t.handles || []).length;
      caption.textContent = (t.caption || el.dataset.caption || '').replace('[count]', n);
      [...dots.children].forEach((d, j) => {
        if (j === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    };

    const setShown = (value) => {
      shown = value;
      parts().forEach((p) => { p.hidden = !value; });
    };

    document.addEventListener('ka:collapse', () => setShown(false));
    $('[data-prev]', el).addEventListener('click', () => render(i - 1));
    $('[data-next]', el).addEventListener('click', () => render(i + 1));
    $('[data-topic-open]', el).addEventListener('click', (e) => {
      e.preventDefault();
      emit('ka:topic', { id: topics[i].id });
      setShown(true);
      setTimeout(() => {
        const content = document.getElementById('content');
        if (content) content.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 60);
    });
    document.addEventListener('ka:collection', (e) => {
      const k = topics.findIndex((t) => t.id === e.detail.id);
      if (k >= 0) render(k);
    });
    /* Kolja, 29 Oct: scrolling back up no longer closes the open line / project; 10 s without activity
       bring the page back to menu mode (header module), which closes it via ka:collapse. */

    render(i);
    if (designMode()) {
      emit('ka:topic', { id: topics[i].id });
      setShown(true);
    }
    /* Deep link (World teasers): ?chapter=<id> opens that chapter / topic directly. Run after all modules are set up. */
    const params = new URLSearchParams(window.location.search);
    const wanted = params.get('chapter') || params.get('collection'); /* ?collection= from the Contact collections band */
    const k = wanted ? topics.findIndex((t) => t.id === wanted) : -1;
    if (k >= 0) {
      setTimeout(() => {
        render(k);
        emit('ka:topic', { id: topics[k].id });
        setShown(true);
        const content = document.getElementById('content');
        if (content) content.scrollIntoView({ block: 'start' });
      }, 0);
    }
  };

  /* Contact collections band: muted looping films; reduced motion keeps the posters. */
  modules['contact-collections'] = (el) => {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    $$('[data-collection-video]', el).forEach((v) => { v.removeAttribute('autoplay'); v.pause(); });
  };

  /* Front / back views on Catalogue and Store tiles (Interaction 3): hover never swaps the image, it only
     reveals ‹ ›, the progress line and the label; ‹ › (or a swipe on touch) flips; the view stays after mouse-leave. */
  const flipTiles = (tiles) => {
    const canHover = window.matchMedia('(hover: hover)');
    tiles.forEach((tile) => {
      if (!$('[data-flip]', tile)) return;
      const label = $('[data-view]', tile);
      const flip = () => {
        const back = tile.classList.toggle('is-back');
        if (label) label.textContent = back ? `${tile.dataset.back || 'Back'} · 2 / 2` : `${tile.dataset.front || 'Front'} · 1 / 2`;
      };
      tile.addEventListener('mouseenter', () => { if (canHover.matches) tile.classList.add('is-hover'); });
      tile.addEventListener('mouseleave', () => tile.classList.remove('is-hover'));
      $$('[data-flip]', tile).forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); flip(); }));
      const media = $('.tile__link, .store-tile__link', tile);
      let x0 = null; let y0 = 0;
      media.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      media.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0; const dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { e.preventDefault(); flip(); }
      });
    });
  };

  /* Catalogue: collection switch, filters (AND across groups, OR within) and tile flips. */
  modules.catalogue = (el) => {
    const source = $('[data-topics]');
    const topics = source ? JSON.parse(source.textContent) : [];
    const tiles = $$('[data-tile]', el);
    /* Handoff 38: Type and Material come from product tags (type:…, material:…), Price from the price. */
    const tagged = (group, id) => (p) => p.tags.includes(`${group}:${id}`);
    const tests = {
      type: { jacket: tagged('type', 'jacket'), hoodie: tagged('type', 'hoodie'), shirt: tagged('type', 'shirt'), pants: tagged('type', 'pants'), shorts: tagged('type', 'shorts') },
      material: { python: tagged('material', 'python'), leather: tagged('material', 'leather'), cotton: tagged('material', 'cotton') },
      price: {
        p1: (p) => p.price < 1000,
        p2: (p) => p.price >= 1000 && p.price <= 2500,
        p3: (p) => p.price > 2500
      }
    };
    const state = {
      col: (source && source.dataset.current) || 'all',
      mto: false,
      type: new Set(), material: new Set(), price: new Set()
    };
    if (topics.length && !topics.some((t) => t.id === state.col)) state.col = topics[0].id;

    const anyOf = (group, p) => state[group].size === 0 || [...state[group]].some((id) => tests[group][id](p));

    const apply = () => {
      const topic = topics.find((t) => t.id === state.col);
      const order = topic ? topic.handles : tiles.map((t) => t.dataset.handle);
      let count = 0;
      tiles.forEach((tile) => {
        const p = { tags: (tile.dataset.tags || '').split(/\s+/).filter(Boolean), price: parseFloat(tile.dataset.price) || 0 };
        const pos = order.indexOf(tile.dataset.handle);
        const visible = pos >= 0
          && (!state.mto || tile.dataset.mto === 'true')
          && anyOf('type', p) && anyOf('material', p) && anyOf('price', p);
        tile.hidden = !visible;
        tile.style.order = pos;
        if (visible) count += 1;
      });
      $('[data-count]', el).textContent = count;
      if (topic) {
        $('[data-catalogue-title]', el).textContent = topic.title;
        $('[data-catalogue-lead]', el).textContent = topic.lead || '';
      }
      $$('[data-collection]', el).forEach((b) => b.classList.toggle('is-active', b.dataset.collection === state.col));
      $$('[data-filter]', el).forEach((b) => {
        const [group, id] = b.dataset.filter.split(':');
        b.setAttribute('aria-pressed', state[group].has(id));
      });
      $('[data-mto]', el).setAttribute('aria-pressed', state.mto);
    };

    $$('[data-collection]', el).forEach((b) => b.addEventListener('click', () => {
      state.col = b.dataset.collection;
      emit('ka:collection', { id: state.col });
      apply();
    }));
    document.addEventListener('ka:topic', (e) => { state.col = e.detail.id; apply(); });

    const toggle = $('[data-filters-toggle]', el);
    const panel = $('[data-filters]', el);
    toggle.addEventListener('click', () => {
      panel.hidden = !panel.hidden;
      $('[data-chevron]', el).textContent = panel.hidden ? '›' : '⌄';
      toggle.setAttribute('aria-expanded', !panel.hidden);
    });
    $('[data-mto]', el).addEventListener('click', () => { state.mto = !state.mto; apply(); });
    $$('[data-filter]', el).forEach((b) => b.addEventListener('click', () => {
      const [group, id] = b.dataset.filter.split(':');
      if (state[group].has(id)) state[group].delete(id); else state[group].add(id);
      apply();
    }));
    $('[data-clear]', el).addEventListener('click', () => {
      state.mto = false;
      state.type.clear(); state.material.clear(); state.price.clear();
      apply();
    });

    flipTiles(tiles);

    apply();
  };

  /* Product page: gallery, variant buttons, Add to bag over /cart/add.js, accordion tabs. */
  modules.product = (el) => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* Gallery: every image opens the light lightbox; ‹ › cycle, Escape closes. */
    const tiles = $$('[data-media]', el);
    const box = $('[data-pdp-lightbox]');
    if (box && tiles.length) {
      const img = $('[data-lb-img]', box);
      const cap = $('[data-lb-caption]', box);
      let k = 0;
      let lastFocus = null;
      const show = (n) => {
        k = (n + tiles.length) % tiles.length;
        img.src = tiles[k].dataset.src;
        img.alt = tiles[k].dataset.label;
        cap.textContent = `${tiles[k].dataset.label} · ${k + 1} / ${tiles.length}`;
      };
      const close = () => {
        box.hidden = true;
        document.body.classList.remove('is-lightbox-open');
        if (lastFocus) lastFocus.focus();
      };
      tiles.forEach((t, n) => t.addEventListener('click', () => {
        lastFocus = t;
        show(n);
        box.hidden = false;
        document.body.classList.add('is-lightbox-open');
        $('[data-lb-close]', box).focus();
      }));
      $$('[data-lb-prev], [data-lb-next]', box).forEach((b) => { b.hidden = tiles.length < 2; });
      $('[data-lb-prev]', box).addEventListener('click', () => show(k - 1));
      $('[data-lb-next]', box).addEventListener('click', () => show(k + 1));
      $('[data-lb-close]', box).addEventListener('click', close);
      box.addEventListener('click', (e) => { if (e.target === box) close(); });
      document.addEventListener('keydown', (e) => {
        if (box.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(k - 1);
        if (e.key === 'ArrowRight') show(k + 1);
      });
    }

    const form = $('[data-product-form]', el);
    const add = $('[data-add]', el);
    const input = $('[data-variant-input]', el);
    const error = $('[data-error]', el);
    const sizes = $$('[data-variant-id]', el);
    const selected = () => sizes.find((b) => b.getAttribute('aria-pressed') === 'true');
    const setLabel = (added) => {
      if (!add) return;
      const size = selected();
      const available = !size || size.dataset.available === 'true';
      add.disabled = !available;
      if (!available) { add.textContent = add.dataset.labelSoldOut; return; }
      const label = added ? add.dataset.labelAdded : add.dataset.labelAdd;
      add.textContent = size ? `${label} — ${size.dataset.label}` : label;
    };
    sizes.forEach((b) => b.addEventListener('click', () => {
      sizes.forEach((o) => o.setAttribute('aria-pressed', o === b));
      if (input) input.value = b.dataset.variantId;
      const priceEl = $('.pdp__price[data-price]', el);
      if (priceEl && b.dataset.price) priceEl.textContent = b.dataset.price;
      if (error) error.hidden = true;
      setLabel(false);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', b.dataset.variantId);
      window.history.replaceState({}, '', url);
    }));

    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!signedIn()) { toSignIn(); return; }
        add.disabled = true;
        error.hidden = true;
        try {
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: input.value, quantity: 1 })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Error');
          setLabel(true);
          const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
          $$('[data-bag-count]').forEach((n) => { n.textContent = cart.item_count; });
        } catch (err) {
          error.textContent = err.message;
          error.hidden = false;
        }
        add.disabled = false;
      });
    }

    /* Tabs: one open at a time. */
    const toggles = $$('[data-tab]', el);
    const openTab = (key) => toggles.forEach((t) => {
      const open = t.dataset.tab === key;
      t.setAttribute('aria-expanded', open);
      $('[data-sign]', t).textContent = open ? '–' : '+';
      $(`[data-tab-body="${t.dataset.tab}"]`, el).hidden = !open;
    });
    toggles.forEach((t) => t.addEventListener('click', () => openTab(t.getAttribute('aria-expanded') === 'true' ? '' : t.dataset.tab)));
    $$('[data-open-tab]', el).forEach((a) => a.addEventListener('click', () => openTab(a.dataset.openTab)));
  };

  /* Private store: collection tabs, front / back views, Add to bag on one-size pieces. */
  modules.store = (el) => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const source = $('[data-store-tabs]');
    const lists = source ? JSON.parse(source.textContent) : {};
    const tiles = $$('[data-tile]', el);
    const tabs = $$('[data-store-tab]', el);
    const pick = (id) => {
      const order = lists[id];
      let count = 0;
      tiles.forEach((tile, k) => {
        const pos = order ? order.indexOf(tile.dataset.handle) : k;
        tile.hidden = pos < 0;
        tile.style.order = pos;
        if (pos >= 0) count += 1;
      });
      $('[data-count]', el).textContent = count;
      tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.storeTab === id));
    };
    tabs.forEach((t) => t.addEventListener('click', () => pick(t.dataset.storeTab)));

    flipTiles(tiles);

    $$('[data-store-add]', el).forEach((button) => button.addEventListener('click', async () => {
      if (!signedIn()) { toSignIn(); return; }
      button.disabled = true;
      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: button.dataset.storeAdd, quantity: 1 })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        button.textContent = button.dataset.labelAdded;
        const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        $$('[data-bag-count]').forEach((n) => { n.textContent = cart.item_count; });
      } catch (err) {
        button.textContent = err.message;
      }
      button.disabled = false;
    }));
  };

  /* Showroom pop-up: once per visitor, after the delay or at 50 % scroll. */
  modules.popup = (el) => {
    const KEY = 'ka_showroom_popup';
    const DAY = 24 * 60 * 60 * 1000;
    const days = parseFloat(el.dataset.days) || 30;
    const card = $('.popup__card', el);
    let opened = false;
    let lastFocus = null;

    /* Handoff 62 (5): count page views of this visit; the pop-up comes from the second one. */
    let views = 2;
    try { views = (parseInt(sessionStorage.getItem('ka-views'), 10) || 0); } catch (e) { /* storage blocked */ }
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } };
    const write = (value) => { try { localStorage.setItem(KEY, JSON.stringify(value)); } catch (e) { /* private mode */ } };
    const seen = () => { const s = read(); return s.never || (s.until && s.until > Date.now()); };
    const busy = () => document.body.classList.contains('is-menu-open') || document.body.classList.contains('is-lightbox-open');

    const close = () => {
      if (opened && !read().never) write({ until: Date.now() + days * DAY }); /* dismissed: pause for `days` */
      el.classList.remove('is-open');
      el.hidden = true;
      document.body.classList.remove('is-popup-open');
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    const onKey = (e) => {
      if (e.key === 'Escape') close();
      if (e.key !== 'Tab') return;
      const items = $$('a[href], button', card);
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    const open = (force) => {
      if (opened && !force) return;
      if (!force && busy()) { setTimeout(() => open(), 1000); return; }
      opened = true;
      lastFocus = document.activeElement;
      el.hidden = false;
      document.body.classList.add('is-popup-open');
      requestAnimationFrame(() => el.classList.add('is-open'));
      setTimeout(() => el.classList.add('is-open'), 50);
      card.focus({ preventScroll: true });
      document.addEventListener('keydown', onKey);
    };

    $$('[data-popup-close]', el).forEach((b) => b.addEventListener('click', close));
    el.addEventListener('click', (e) => { if (e.target === el) close(); });
    const cta = $('[data-popup-cta]', el);
    if (cta) cta.addEventListener('click', () => write({ never: true }));

    if (designMode()) {
      document.addEventListener('shopify:section:select', (e) => { if (e.target.contains(el)) open(true); });
      document.addEventListener('shopify:section:deselect', (e) => { if (e.target.contains(el)) close(); });
      return;
    }
    if (seen() || views < 2) return;
    const trigger = el.dataset.trigger || 'both';
    if (trigger !== 'scroll') setTimeout(() => open(), (parseFloat(el.dataset.delay) || 0) * 1000);
    if (trigger !== 'delay') {
      const onScroll = () => {
        const range = document.documentElement.scrollHeight - window.innerHeight;
        if (range > 0 && window.scrollY / range >= 0.5) { window.removeEventListener('scroll', onScroll); open(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  };

  /* Contact form: interest pills, pre-selection from ?piece=, focus on the confirmation. */
  modules.contact = (el) => {
    const thanks = $('[data-thanks]', el);
    if (thanks) { thanks.focus(); return; }
    const pills = $$('[data-interest]', el);
    const field = $('[data-interests]', el);
    const sync = () => {
      field.value = pills.filter((p) => p.getAttribute('aria-pressed') === 'true').map((p) => p.dataset.interest).join(', ');
    };
    pills.forEach((p) => p.addEventListener('click', () => {
      p.setAttribute('aria-pressed', p.getAttribute('aria-pressed') !== 'true');
      sync();
    }));
    const piece = new URLSearchParams(window.location.search).get('piece');
    if (piece) {
      $('[data-piece]', el).value = piece;
      const match = pills.find((p) => (p.dataset.handles || '').split(' ').includes(piece) && !/highlights/i.test(p.dataset.interest))
        || pills.find((p) => (p.dataset.handles || '').split(' ').includes(piece));
      if (match) match.setAttribute('aria-pressed', 'true');
      sync();
    }
  };

  /* Projects: chapter tabs, mosaic and the full-screen lightbox. */
  modules.projects = (el) => {
    const tabs = $$('[data-chapter-tab]', el);
    const box = $('[data-lightbox]');
    const stage = $('[data-lightbox-stage]', box);
    const caption = $('[data-lightbox-caption]', box);
    let chapter = tabs.length ? tabs[0].dataset.chapterTab : null;
    let items = [];
    let index = 0;
    let lastFocus = null;

    const show = (id) => {
      if (!$(`[data-chapter="${id}"]`, el)) return;
      chapter = id;
      tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.chapterTab === id));
      $$('[data-chapter]', el).forEach((m) => { m.hidden = m.dataset.chapter !== id; });
      $$('[data-chapter-intro]', el).forEach((m) => { m.hidden = m.dataset.chapterIntro !== id; });
      $$('[data-chapter-parts]', el).forEach((m) => { m.hidden = m.dataset.chapterParts !== id; });
    };

    /* Handoff 53: gallery chapters show one part at a time (or All). For the visible set the first photo
       takes span 7 with the chapter's text tile beside it, then a repeating rhythm of 3 × span 4 and 2 × span 6. */
    /* Without a text tile (Handoff 54) the rhythm is 6-6 / 4-4-4 / 4-4-4 from the first photo. */
    const RHYTHM = [4, 4, 4, 6, 6];
    const RHYTHM_NO_TEXT = [6, 6, 4, 4, 4, 4, 4, 4];
    const layout = (mosaic) => {
      const part = +mosaic.dataset.partActive || 0;
      const shots = $$('.frame--gallery', mosaic);
      const withText = !!$('.etile', mosaic);
      let i = 0;
      shots.forEach((f) => {
        const on = part === 0 || +f.dataset.part === part;
        f.hidden = !on;
        if (!on) return;
        f.style.order = i === 0 ? 0 : i + 1;
        const computed = withText ? (i === 0 ? 7 : RHYTHM[(i - 1) % RHYTHM.length]) : RHYTHM_NO_TEXT[i % RHYTHM_NO_TEXT.length];
        const span = +f.dataset.span || computed; /* Handoff 56: a "|span" in the files list wins */
        f.style.setProperty('--span', span);
        i += 1;
      });
      $$('.etile', mosaic).forEach((t) => { t.style.order = 1; });
    };
    $$('[data-parts]', el).forEach((mosaic) => {
      layout(mosaic);
      const row = $(`[data-chapter-parts="${mosaic.dataset.chapter}"]`, el);
      if (!row) return;
      $$('[data-part]', row).forEach((b) => b.addEventListener('click', () => {
        mosaic.dataset.partActive = b.dataset.part;
        $$('[data-part]', row).forEach((x) => x.classList.toggle('is-active', x === b));
        layout(mosaic);
      }));
    });

    /* Films: muted inline loops start when ≥ 50 % of the film is in view and pause outside it,
       so only the film you scroll to plays (hidden chapters never intersect). */
    const inline = $$('[data-film] video', el);
    const visible = new Set();
    const play = (v) => { const p = v.play(); if (p) p.catch(() => {}); };
    const sync = () => inline.forEach((v) => { if (visible.has(v) && box.hidden) play(v); else v.pause(); });
    if (inline.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting && e.intersectionRatio >= 0.5) visible.add(e.target); else visible.delete(e.target); });
        sync();
      }, { threshold: [0, 0.5, 1] });
      inline.forEach((v) => io.observe(v));
    }
    tabs.forEach((t) => t.addEventListener('click', () => { show(t.dataset.chapterTab); emit('ka:collection', { id: t.dataset.chapterTab }); }));
    document.addEventListener('ka:topic', (e) => show(e.detail.id));

    const render = () => {
      const item = items[index];
      stage.innerHTML = '';
      if (item.video) {
        const v = document.createElement('video');
        v.src = item.video; v.controls = true; v.autoplay = true; v.playsInline = true;
        if (item.poster) v.poster = item.poster;
        stage.appendChild(v);
      } else if (item.src) {
        const img = document.createElement('img');
        img.src = item.src; img.alt = item.label;
        stage.appendChild(img);
      } else {
        const span = document.createElement('span');
        span.className = 'lightbox__empty';
        span.textContent = `[${item.label} — ${box.dataset.empty || 'full-resolution frame to be supplied'}]`;
        stage.appendChild(span);
      }
      caption.textContent = `${item.label} · ${index + 1} / ${items.length}`;
      $$('[data-lightbox-prev], [data-lightbox-next]', box).forEach((b) => { b.hidden = items.length < 2; });
    };
    const open = (list, k) => {
      items = list; index = k;
      lastFocus = document.activeElement;
      render();
      box.hidden = false;
      sync();
      document.body.classList.add('is-lightbox-open');
      $('[data-lightbox-close]', box).focus();
    };
    const close = () => {
      box.hidden = true;
      stage.innerHTML = '';
      document.body.classList.remove('is-lightbox-open');
      sync();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    const step = (d) => { index = (index + d + items.length) % items.length; render(); };

    $$('[data-chapter]', el).forEach((mosaic) => {
      const frames = $$('[data-frame]', mosaic);
      const films = $$('[data-film]', mosaic);
      /* The lightbox cycles only through the frames currently shown (the selected part, or all). */
      const shown = () => frames.filter((f) => !f.hidden).sort((x, y) => (+x.style.order || 0) - (+y.style.order || 0));
      const filmItems = films.map((f) => ({ label: f.dataset.label, video: f.dataset.video, poster: f.dataset.poster }));
      frames.forEach((f) => f.addEventListener('click', () => {
        const list = shown();
        open(list.map((x) => ({ label: x.dataset.label, src: x.dataset.src })), Math.max(0, list.indexOf(f)));
      }));
      films.forEach((f, k) => {
        f.addEventListener('click', () => open(filmItems, k));
        f.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(filmItems, k); } });
      });
    });
    /* Handoff 62 (16): "↑ Chapters" once a chapter is open and the page is scrolled past 600 px. */
    const toChapters = $('[data-to-chapters]');
    const nav = $('.projects__tabs', el);
    if (toChapters && nav) {
      const syncPill = () => { toChapters.hidden = el.hidden || window.scrollY < 600; };
      window.addEventListener('scroll', syncPill, { passive: true });
      new MutationObserver(syncPill).observe(el, { attributes: true, attributeFilter: ['hidden'] });
      toChapters.addEventListener('click', () => nav.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      syncPill();
    }
    $('[data-lightbox-close]', box).addEventListener('click', close);
    $('[data-lightbox-prev]', box).addEventListener('click', () => step(-1));
    $('[data-lightbox-next]', box).addEventListener('click', () => step(1));
    box.addEventListener('click', (e) => { if (e.target === box || e.target === stage) close(); });
    document.addEventListener('keydown', (e) => {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
    if (chapter) show(chapter);
  };

  /* Legal pages: side navigation built from the h2 headings (fallback h3, then numbered bold lines). */
  const buildLegalNav = (body, nav) => {
    const skip = /^\s*(table of contents|inhaltsverzeichnis)\s*$/i;
    const numbered = /^\s*(\d+|[A-Z])[\.\)]\s+\S/;
    const levels = [
      () => $$('h2', body).filter((h) => !skip.test(h.textContent)),
      () => $$('h3', body).filter((h) => !skip.test(h.textContent)),
      () => $$('h4', body).filter((h) => !skip.test(h.textContent)),
      () => {
        const bold = $$('strong, b', body).filter((h) => numbered.test(h.textContent) && h.textContent.trim().length < 120);
        return bold.filter((h) => !bold.some((o) => o !== h && o.contains(h)));
      }
    ];
    let heads = [];
    for (const level of levels) { heads = level(); if (heads.length >= 2) break; }
    if (heads.length < 2) return;
    nav.innerHTML = '';
    const used = new Set();
    heads.forEach((h, i) => {
      const text = h.textContent.replace(/\s+/g, ' ').trim();
      let id = h.id || text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || `section-${i + 1}`;
      while (used.has(id)) id += '-2';
      used.add(id);
      const target = h.closest('p') && !/^H\d$/.test(h.tagName) ? h.closest('p') : h;
      target.id = id;
      target.classList.add('legal-doc__anchor');
      const a = document.createElement('a');
      a.href = `#${id}`;
      a.textContent = h.dataset.navLabel || text.replace(/^(\d+|[A-Z])[\.\)]\s*/, '$1 ').replace(/:$/, '');
      nav.appendChild(a);
    });
    nav.hidden = false;
    /* The side navigation replaces an inline table of contents. */
    $$('h1, h2, h3, h4, p', body).filter((h) => skip.test(h.textContent)).forEach((h) => {
      h.hidden = true;
      let next = h.nextElementSibling;
      while (next && /^(UL|OL)$/.test(next.tagName)) { next.hidden = true; next = next.nextElementSibling; }
    });
    const links = $$('a', nav);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          links.forEach((l) => {
            if (l.hash === `#${e.target.id}`) l.setAttribute('aria-current', 'true');
            else l.removeAttribute('aria-current');
          });
        });
      }, { rootMargin: '0px 0px -70% 0px' });
      links.forEach((l) => { const t = document.getElementById(l.hash.slice(1)); if (t) io.observe(t); });
    }
  };
  modules.legalnav = (el) => buildLegalNav($('[data-legal-body]', el), $('[data-legal-nav]', el));

  /* /policies/*: wrap Shopify's policy markup into the same shell as the legal pages. */
  const shapePolicy = () => {
    const box = $('.shopify-policy__container');
    if (!box || box.dataset.shaped) return;
    box.dataset.shaped = 'true';
    box.classList.add('service', 'legal-doc');
    const title = $('.shopify-policy__title', box);
    if (title) title.classList.add('service__head');
    const body = $('.shopify-policy__body', box);
    if (!body) return;
    const grid = document.createElement('div');
    grid.className = 'legal-doc__grid';
    const nav = document.createElement('nav');
    nav.className = 'legal-doc__nav';
    nav.hidden = true;
    body.classList.add('legal-doc__body');
    body.parentNode.insertBefore(grid, body);
    grid.appendChild(nav);
    grid.appendChild(body);
    buildLegalNav(body, nav);
  };

  /* Bag: ± and Remove via /cart/change.js, then re-render the section in place; note via /cart/update.js. */
  modules.bag = (el) => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const id = el.dataset.section;
    const host = el.closest('.shopify-section') || el.parentNode;
    const post = (url, body) => fetch(`${root}${url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then((r) => r.json().then((data) => ({ ok: r.ok, data })));
    const swap = (sections, count, message, lineNo) => {
      const html = sections && sections[id];
      if (!html) { window.location.reload(); return; }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      host.replaceChildren(...doc.body.firstElementChild.childNodes);
      boot(host);
      if (count != null) $$('[data-bag-count]').forEach((n) => { n.textContent = count; });
      if (message) {
        const line = $(`[data-line="${lineNo}"] .bag-line__text`, host);
        if (line) {
          const span = document.createElement('span');
          span.className = 'bag-line__error';
          span.textContent = message;
          line.appendChild(span);
        }
      }
    };
    el.addEventListener('click', (e) => {
      const b = e.target.closest('[data-qty]');
      if (!b) return;
      const lineNo = +b.closest('[data-line]').dataset.line;
      el.classList.add('is-busy');
      post('cart/change.js', { line: lineNo, quantity: Math.max(0, +b.dataset.qty), sections: [id] })
        .then(({ ok, data }) => {
          if (ok) { swap(data.sections, data.item_count); return null; }
          /* e.g. not enough stock: show Shopify's message and re-render the current bag */
          return fetch(`${root}cart?sections=${id}`).then((r) => r.json())
            .then((sections) => fetch(`${root}cart.js`).then((r) => r.json())
              .then((cart) => swap(sections, cart.item_count, data.description || data.message, lineNo)));
        })
        .catch(() => window.location.reload());
    });
    const note = $('[data-note]', el);
    if (note) {
      let t;
      note.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => post('cart/update.js', { note: note.value }), 500); });
    }
  };

  /* Client page: panel navigation (Your pieces shows pieces and orders, as in the board). */
  modules.client = (el) => {
    const tabs = $$('[data-tab]', el);
    tabs.forEach((t) => t.addEventListener('click', () => {
      tabs.forEach((o) => { if (o === t) o.setAttribute('aria-current', 'true'); else o.removeAttribute('aria-current'); });
      $$('[data-panel]', el).forEach((p) => { p.hidden = !p.dataset.panel.split(' ').includes(t.dataset.tab); });
    }));
  };

  const boot = (root = document) => {
    $$('[data-module]', root).forEach((el) => {
      if (el.dataset.booted) return;
      const init = modules[el.dataset.module];
      if (!init) return;
      el.dataset.booted = 'true';
      init(el);
    });
  };
  /* Content sections first, so they hear the topic carousel's first event. */
  const start = () => {
    const order = ['catalogue', 'projects'];
    order.forEach((name) => $$(`[data-module="${name}"]`).forEach((el) => { el.dataset.booted = 'true'; modules[name](el); }));
    boot();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { shapePolicy(); stickyHeader(); start(); });
  else { shapePolicy(); stickyHeader(); start(); }
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
